import { render } from "./EditProduct.vue?vue&type=template&id=274a3ce0&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=274a3ce0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-274a3ce0"

export default script